<template>
  <v-expansion-panel class="expansion-filter-panel">
    <v-expansion-panel-header class="expansion-filter-panel-header__primary" :disable-icon-rotate="true">
      <strong
        ><span>{{ title }}</span></strong
      >
      <template v-slot:actions>
        <v-icon color="#404046">
          {{ selectedPanels.includes(index) ? "mdi-menu-up" : "mdi-menu-down" }}
        </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="expansion-panel__content">
      <v-row>
        <v-col cols="12">
          <slot></slot>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "SimpleExpensionPanel",
  props: {
    title: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    selectedPanels: {
      type: Array,
      deault: [],
    },
  },
};
</script>

<style lang="scss" scoped>
.expansion-filter-panel {
  margin-bottom: 1em;
  &__content {
    padding: 0.5em 0.2em;
  }

  &-header {
    &__primary {
      display: flex;
      justify-content: center;
      text-align: center !important;
      background-color: transparent !important;
      position: relative;
      padding: 14px 0;
      & strong {
        font-family: Arial, sans-serif !important;
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 13.8px !important;
        color: #494949 !important;
        text-transform: uppercase !important;
        display: block;
        width: 100%;
        border-bottom: 1px solid #cdcdcd !important;
        text-align: center;
        & span {
          position: absolute;
          left: 38%;
          padding: 0 2em;
          width: 300px;
          top: 18px;
          background-color: #f0f0f0;
        }
      }
    }
  }
  &::v-deep  .v-expansion-panel-content__wrap{
  padding: .25em 0!important;
}

&::v-deep .v-expansion-panel-header {
  &:before {
    background-color: transparent;
  }
} 

}

.v-expansion-panel {
  background-color: transparent !important;
  &--active > .v-expansion-panel-header {
    min-height: auto !important;
  }
}


</style>
